
import styled from "styled-components";
import {fmoney} from '../../../utils/utils'
export default function ClaimConfrim({amount,time,intl}) {

  return (
    <Wrapper>
      <Text>
        <span className="t">本次提币</span> <span className="v">{amount} RT</span>
      </Text>
      <Text>
      <span className="t">手续费</span> <span className="v">0.8 RT </span>
      </Text>
      <Text >
      <span className="t">实际到账</span> <span className="v">{parseFloat((amount-0.8).toFixed(4))} RT</span>
      </Text>
      {/* <Squre>
        <img src="/image/Rb.png" alt=""></img>
        <p>{fmoney(amount,2)}</p>
      </Squre> */}
      <Text style={{textAlign:'center'}}>{
       intl.formatMessage({
        id: "是否继续？",
      })}</Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
`;

const Text = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.6rem;
  color: #000;
  display: flex;
  /* span {
    color: #ff5c00;
  } */
  margin-bottom: 1.0rem;
  justify-content: center;
  span {
    width: 50%;
  }
  .t{
    text-align: right;
    margin-right: 1.0rem;
  }
  .v{
    text-align: left;
  }
`;

const Squre = styled.div`
  background: #f4f5f6;
  border-radius: 1.6rem;

  width: 8.6rem;
  height: 8.6rem;
  margin: 2.0rem auto;
  padding: 1.5rem 1.6rem;
  box-sizing: border-box;
  img {
    width: 2.6rem;
  }
  p {
    font-style: normal;
    font-weight: 600;
    font-size: 1.6rem;
    line-height: 2.0rem;
    color: #000000;

    margin-top: .5rem;
  }
`;
